import React from 'react';
import { StarIcon } from 'lucide-react';
import { Button, TrustBar } from './Shared';
const STATS = [{
  value: '+300',
  label: 'familias confían'
}, {
  value: '6',
  label: 'tomos listos'
}, {
  value: '4.9/5',
  label: 'calificación'
}, {
  value: '🇺🇾',
  label: 'todo Uruguay'
}];
const HERO_TESTIMONIALS = [{
  initials: 'VG',
  quote: 'Mi hijo me pide la etiqueta del jueves.',
  author: 'Valentina G., Montevideo',
  tag: 'Mamá de 9 años'
}, {
  initials: 'MF',
  quote: 'Desde que uso el sistema mi hijo come todo.',
  author: 'Marcela F., Rivera',
  tag: 'Mamá de 7 años'
}, {
  initials: 'LM',
  quote: 'Me sacó esa sensación para siempre.',
  author: 'Laura M., Montevideo',
  tag: 'Mamá de 5 años'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-lightBlue px-4 pb-16 pt-8 text-center md:pb-20 md:pt-12" data-id="element-64">
      <div className="mx-auto w-full max-w-5xl" data-id="element-65">
        <p className="mb-3 flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-brand-orange md:mb-5 md:text-sm" data-id="element-66">
          🌟 Tu Fénix Digital
        </p>
        <h1 className="mx-auto max-w-4xl font-display text-4xl font-bold leading-[1.08] text-brand-deep sm:text-5xl md:text-6xl lg:text-7xl" data-id="element-67">
          La merienda de tu hijo{' '}
          <span className="text-brand-orange" data-id="element-68">resuelta.</span>
          <br data-id="element-69" />
          La culpa de las mañanas,{' '}
          <span className="text-brand-orange" data-id="element-70">terminada.</span>
        </h1>
        <p className="mt-5 font-display text-base font-bold uppercase tracking-[0.17em] text-brand-blue md:text-lg" data-id="element-71">
          Meriendas que Acompañan
        </p>

        <div className="mx-auto my-7 max-w-[280px] sm:max-w-md md:my-9 md:max-w-lg" data-id="element-72">
          <img src="https://cdn.magicpatterns.com/uploads/6MvDBad2Cc5yMfAKgLFa9m/mockup_MERIENDA_QUE_ACOMPANAN.png" alt="Mockup del Mega Pack Meriendas que Acompañan con 6 tomos y 3 bonos" width="1440" height="1440" fetchPriority="high" decoding="async" className="w-full rounded-[2rem] shadow-[0_20px_50px_rgba(13,59,110,0.18)]" data-id="element-73" />
        </div>

        <p className="mx-auto max-w-3xl text-base font-medium leading-relaxed text-brand-text md:text-xl" data-id="element-74">
          El sistema que usan las familias uruguayas para resolver la merienda
          escolar de toda la semana en una sola tarde — y dejar de cargar con
          esa sensación todos los días.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-2 md:mt-8 md:gap-3" data-id="element-75">
          {['📄 100% PDF', '⚡ Acceso inmediato', '🇺🇾 Para familias uruguayas 2026'].map(pill => <span key={pill} className="rounded-full border border-brand-sky bg-white px-4 py-2 text-xs font-semibold text-brand-blue shadow-sm md:text-sm" data-id="element-76">
              {pill}
            </span>)}
        </div>
        <div className="mx-auto mt-7 max-w-md" data-id="element-77">
          <Button className="py-5" data-id="element-78">🌟 QUIERO MI KIT AHORA — $390 UYU</Button>
        </div>
        <div className="mt-4" data-id="element-79">
          <TrustBar data-id="element-80" />
        </div>

        <div className="mt-14 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4" data-id="element-81">
          {STATS.map(stat => <div key={stat.label} className="rounded-2xl border border-brand-sky bg-white px-3 py-5 shadow-sm" data-id="element-82">
              <p className="font-display text-3xl font-bold text-brand-blue md:text-4xl" data-id="element-83">
                {stat.value}
              </p>
              <p className="mt-1 text-sm font-medium leading-tight text-brand-text" data-id="element-84">
                {stat.label}
              </p>
            </div>)}
        </div>

        <div className="mt-10 grid gap-4 text-left md:grid-cols-3" data-id="element-85">
          {HERO_TESTIMONIALS.map(testimonial => <article key={testimonial.initials} className="flex flex-col rounded-2xl border border-slate-100 bg-white p-5 shadow-sm" data-id="element-86">
              <div className="mb-3 flex text-yellow-400" aria-label="5 de 5 estrellas" data-id="element-87">
                {Array.from({
              length: 5
            }).map((_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" data-id="element-88" />)}
              </div>
              <p className="flex-1 font-semibold text-brand-deep" data-id="element-89">
                “{testimonial.quote}”
              </p>
              <div className="mt-5 flex items-center gap-3" data-id="element-90">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-blue text-sm font-bold text-white" data-id="element-91">
                  {testimonial.initials}
                </span>
                <span data-id="element-92">
                  <strong className="block text-sm text-brand-text" data-id="element-93">
                    {testimonial.author}
                  </strong>
                  <small className="text-brand-gray" data-id="element-94">{testimonial.tag}</small>
                </span>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}